import { useRef, useState } from "react";
import { useLanguage } from '../switchLang/useLang';
import "./InlineSubscribe.css";

export function MailchimpSubscribeForm() {
    const { t } = useLanguage();
    const emailRef = useRef(null);

    const [message, setMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // НОВЫЙ СТЕЙТ ДЛЯ ЗАГРУЗКИ

    const handleSubmit = (e) => {
        e.preventDefault();

        // Включаем лоадер и ставим нейтральное сообщение
        setIsLoading(true);
        setIsSuccess(false);
        setMessage("⏳ Sending request, please wait...");

        const email = emailRef.current.value;
        const baseUrl = "https://crytivo.us12.list-manage.com/subscribe/post-json";

        const params = new URLSearchParams({
            u: "9a67a376226e7f3db13056c73",
            id: "437627bdee",
            EMAIL: email,
            tags: "12061353",
            f_id: "00d547e0f0",
            c: "callback"
        });

        params.append("b_9a67a376226e7f3db13056c73_437627bdee", "");

        const script = document.createElement("script");
        script.src = `${baseUrl}?${params.toString()}`;

        window.callback = function (data) {
            console.log("Mailchimp response:", data);

            setIsLoading(false); // ВЫКЛЮЧАЕМ ЛОАДЕР при получении ответа

            if (data.result === "success") {
                setIsSuccess(true);
                setMessage("✓ Success! Redirecting to Kickstarter...");

                if (typeof window !== 'undefined' && window.fbq) {
                    window.fbq('track', 'Lead');
                }

                setTimeout(() => {
                    window.location.href = "https://www.kickstarter.com/projects/gardenofdreamsgames/silicone-heart?ref=2kj5s8";
                }, 2000);

            } else {
                setIsSuccess(false);
                setMessage("✕ " + (data.msg || "Error occurred."));
            }

            document.body.removeChild(script);
            delete window.callback;
        };

        document.body.appendChild(script);
    };

    // Определяем класс для сообщения (зеленый, красный или желтый-нейтральный для лоадера)
    const messageClass = isLoading ? "loading" : (isSuccess ? "success" : "error");

    return (
        <form className="inlineSubscribeForm" onSubmit={handleSubmit}>
            <div className="inlineInputGroup">
                <input
                    className="inlineSubscribeInput"
                    type="email"
                    ref={emailRef}
                    placeholder="Enter your email"
                    required
                    disabled={isLoading} // Блокируем инпут во время загрузки
                />
                <button
                    className="inlineSubscribeBtn"
                    type="submit"
                    disabled={isLoading} // Блокируем кнопку во время загрузки
                >
                    {isLoading ? "WAIT..." : "SIGN UP"} {/* Меняем текст кнопки */}
                </button>
            </div>

            {message && (
                <div className={`inlineMessage ${messageClass}`}>
                    <span dangerouslySetInnerHTML={{ __html: message }} />
                </div>
            )}
        </form>
    );
}